import { render, staticRenderFns } from "./PolicyEditor.vue?vue&type=template&id=dc27c092&scoped=true&"
import script from "./PolicyEditor.vue?vue&type=script&lang=js&"
export * from "./PolicyEditor.vue?vue&type=script&lang=js&"
import style0 from "./PolicyEditor.css?vue&type=style&index=0&id=dc27c092&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc27c092",
  null
  
)

export default component.exports